import { render, staticRenderFns } from "./PsGroupsDetail.vue?vue&type=template&id=2802bd84&scoped=true&"
import script from "./PsGroupsDetail.vue?vue&type=script&lang=js&"
export * from "./PsGroupsDetail.vue?vue&type=script&lang=js&"
import style0 from "./PsGroupsDetail.vue?vue&type=style&index=0&id=2802bd84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2802bd84",
  null
  
)

export default component.exports